import { API } from "@/services/api";
import { aiEndpoints } from "@/constant/endpoints";
import { IAPIResponse } from "@/services/api.types";
import { AIListingFormData, AIListingResponse } from "@/types/ai.types";

export const generateListingDescriptionService = async (
  payload: AIListingFormData
): Promise<IAPIResponse<AIListingResponse>> => {
  return API.Post<AIListingFormData, AIListingResponse>(aiEndpoints.listingDescription, payload);
};
